import React from "react";
import { withStyles } from "@material-ui/core/styles";
// Material-UI Components
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogActions from "@material-ui/core/DialogActions";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogTitle from "@material-ui/core/DialogTitle";

// Icons
import closeIcon from "../../../assets/icons/close.svg"; // Close icon

const styles = (theme) => ({
  root: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    margin: 0,
    padding: "16px",
    height: "60px",
    borderBottom: "1px solid #e2e8f0",
  },
  closeButton: {},
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      {children}

      {onClose ? (
        <div>
          <img
            className="close"
            src={closeIcon}
            alt="closeIcon"
            onClick={onClose}
          />
        </div>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    paddingTop: "0px",
    paddingBottom: "0px",
    paddingLeft: "20px",
    paddingRight: "20px",
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: 0,
    maxHeight: "60px",
    borderTop: "1px solid #e2e8f0",
  },
}))(MuiDialogActions);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const ConfirmationPopup = ({
  title = "",
  description = "",
  confirmationOnClick = () => {},
  onClose = () => {},
  open = false,
  isConfirmationBtnDisable = false,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
      aria-labelledby="customized-dialog-title"
      maxWidth="xs"
    >
      <DialogTitle id="customized-dialog-title" onClose={onClose}>
        <h4 className="modal-title">{title}</h4>
      </DialogTitle>
      <DialogContent className="new-design-v1">
        <section className="pl-1 pr-4 pt-2 pb-8" style={{ fontSize: "16px" }}>
          {description}
        </section>
      </DialogContent>
      <DialogActions>
        <div
          className="new-design-v1 d-flex pr-4 pt-2 pb-2"
          style={{ gap: "16px" }}
        >
          <button
            className="secondary-button"
            style={{ maxHeight: "32px" }}
            onClick={() => onClose()}
          >
            Cancel
          </button>
          <button
            className="primary-button"
            style={{ maxHeight: "32px" }}
            onClick={confirmationOnClick}
            disabled={isConfirmationBtnDisable}
          >
            {"Yes"}
          </button>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationPopup;
